module.exports = __webpack_public_path__ + "img/Picture 10.f26a4412.png";